import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  styleUrls: ['./sidebar.component.css'],
  template: `
    <div class="sidebar">
      <ng-content></ng-content>
    </div>
  `,
})
export class SidebarComponent {

  constructor() { }

}
